'use client'

import { LocalStorage } from '@/lib/utils/local-storage'
import { useState, useEffect } from 'react'

export function useLocalStorage<T>(
  key: string,
  defaultValue: T
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    return LocalStorage.get<T>(key) ?? defaultValue
  })

  useEffect(() => {
    LocalStorage.set(key, value)
  }, [key, value])

  return [value, setValue]
}
